import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogTitle, IconButton, Button } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import { useSnackbar } from 'notistack';

const ActionsComponent = (props) => {
    const { handleEdit, handleDelete, deletable, label } = props;
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOkClick = () => {
        handleDelete();
        enqueueSnackbar(
            `Uspešno ste obrisali ${label}`, { variant: 'success' });
        handleClose();
    }

    return (
        <>
            <IconButton onClick={handleEdit}>
                <Edit />
            </IconButton>
            { deletable &&
                <IconButton onClick={handleClickOpen}>
                    <Delete />
                </IconButton>
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Da li ste sigurni da želite da obrišete {label}?</DialogTitle>
                    <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Odustani
                    </Button>
                    <Button onClick={handleOkClick} color="primary" autoFocus>
                        U redu
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

ActionsComponent.propTypes = {
    handleEdit: PropTypes.func,
    handleDelete: PropTypes.func,
    deletable: PropTypes.bool,
    label: PropTypes.string
}

export default ActionsComponent;
